module.exports = __webpack_public_path__ + "static/img/ys.5f09419.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/data/ys.png
// module id = Ldkb
// module chunks = 0